import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../state/authSlice";
import { resetCompCode } from "../state/companySlice";
import { useQueryClient } from "@tanstack/react-query";
import { linksUrl } from "../constants/enum";

const UseIdleLogout = (minutes) => {
  console.log(minutes,"dgf")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const timer = useRef(null);

  const resetTimer = () => {
    
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      localStorage.removeItem("token");
      sessionStorage.clear();
      dispatch(setLogout())
      dispatch(resetCompCode())
      queryClient.removeQueries()
      navigate(linksUrl.login)
    }, minutes * 60 * 1000);
  };

  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer(); // start timer

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return null;
};

export default UseIdleLogout;
